import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, ButtonSelect, Icon } from '@saviynt/design-system';

import { refreshProgress } from '../../../../redux/certlist/action';
import { useInvertedLocalize } from '../../../../utils/localization';

import { invertedMessages } from './messages';

function RefreshProgressButton() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const {
    global: { isGlobalLoading },
    core: { totalItems: totalItemsCount },
    tabs: { activeTab, tabsCount },
    lineAction: { certsActionStatus } = {},
  } = useSelector((state) => state?.certifications?.list);

  const l = useInvertedLocalize(invertedMessages);

  const onRefreshProgressClick = () => {
    setLoading(true);
    dispatch(refreshProgress());
  };

  useEffect(() => {
    if (certsActionStatus) {
      setLoading(false);
    }
  }, [certsActionStatus]);

  return (
    <Box className='CertListRefreshProgress'>
      <ButtonSelect
        kind='icon'
        onClick={onRefreshProgressClick}
        ariaLabel={l('Reset')}
        size='medium'
        prefixIcon={
          <Icon ariaLabel={l('Reset')} kind='Reset' size='smallMedium' />
        }
        isVisualCueEnabled={false}
        isDisabled={
          tabsCount[activeTab] === 0 ||
          totalItemsCount === 0 ||
          isGlobalLoading ||
          loading
        }
      />
    </Box>
  );
}

export default RefreshProgressButton;
